import React from "react";
import * as d3 from "d3";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import WiremapGenerator from "../../../../../../common/wiremapGenerator";

class WiremapDiagram extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wmContainerWidth: 680,
      wmLineWidth: props.thumbnailView ? 5.5 : 12,
      colors: {
        Standard: {
          "1": "#000000", //BLACK
          "2": "#000000", //BLACK
          "3": "#000000", //BLACK
          "4": "#000000", //BLACK
          "5": "#000000", //BLACK
          "6": "#000000", //BLACK
          "7": "#000000", //BLACK
          "8": "#000000", //BLACK
          "9": "#000000", //BLACK
          short: "#FF0000" //RED
        },
        "568A": {
          "1": "#648E28", //GREEN
          "2": "#648E28", //GREEN
          "3": "#FFA500", //ORANGE
          "4": "#4267B2", //BLUE
          "5": "#4267B2", //BLUE
          "6": "#FFA500", //ORANGE
          "7": "#74412F", //BROWN
          "8": "#74412F", //BROWN
          "9": "#000000", //BLACK
          short: "#FF0000" //RED
        },
        "568B": {
          "1": "#FFA500", //ORANGE
          "2": "#FFA500", //ORANGE
          "3": "#648E28", //GREEN
          "4": "#4267B2", //BLUE
          "5": "#4267B2", //BLUE
          "6": "#648E28", //GREEN
          "7": "#74412F", //BROWN
          "8": "#74412F", //BROWN
          "9": "#000000", //BLACK
          short: "#FF0000" //RED
        },
        TERA: {
          "1": "#4267B2", //BLUE
          "2": "#4267B2", //BLUE
          "3": "#FFA500", //ORANGE
          "4": "#74412F", //BROWN
          "5": "#74412F", //BROWN
          "6": "#FFA500", //ORANGE
          "7": "#648E28", //GREEN
          "8": "#648E28", //GREEN
          "9": "#000000", //BLACK
          short: "#FF0000" //RED
        },
        VOICE: {
          "1": "#648E28", //GREEN
          "2": "#FFA500", //ORANGE
          "3": "#4267B2", //BLUE
          "4": "#4267B2", //BLUE
          "5": "#FFA500", //ORANGE
          "6": "#648E28", //GREEN
          short: "#FF0000" //RED
        },
        Coax: {
          "4": "#963f0e", //BROWN
          "5": "#969696", //GREY
          short: "#FF0000" //RED
        },
        CoaxNew: {
          "1": "#963f0e", //BROWN
          "2": "#969696", //GREY
          short: "#FF0000" //RED
        }
      }
    };
  }
  render() {
    const {
      translate,
      classes,
      wiremapStandard,
      chartMeasurementUnit,
      data,
      results
    } = this.props;

    if (data) {
      chartMeasurementUnit &&
        WiremapGenerator.setChartMeasurementUnit(chartMeasurementUnit);
      translate && WiremapGenerator.setTranslate(translate);

      let { wmContainerWidth, wmLineWidth } = this.state;
      let wmLineGap = wmLineWidth * 2;
      let wmMarginHor = wmLineWidth * 2;
      let wmHeadTailsWidth = wmLineWidth * 2;
      let wmContainerHeight = (wmLineWidth + wmLineGap) * 9 + wmLineGap;
      let pinOffset = 0;

      let isCoax = results &&
        results.data &&
        results.data.testedcabletype.toLowerCase() == "coaxialcable";

      let colors =
        isCoax
          ? this.state.colors["Coax"]
          : wiremapStandard
            ? this.state.colors[wiremapStandard]
            : this.state.colors["586B"];

      //Texts
      let texts =
        isCoax
          ? ["", "", "", "C", "S"]
          : ["1", "2", "3", "4", "5", "6", "7", "8", "S"];

      if (results && results.data && results.data.testedcabletype == "MobileTest" && results.data.mobileTest.videoCableModeSelected) {

        isCoax = true;
        colors = this.state.colors["CoaxNew"];
        pinOffset = 3;
        texts = [ "C", "S"]
      }

      if (results && results.data && results.data.testedcabletype == "MobileTest" && results.data.mobileTest.voiceCableModeSelected) {

        colors = this.state.colors["VOICE"];
        pinOffset = 1;
        texts = ["1", "2", "3", "4", "5", "6"];
      }

      let textsData = WiremapGenerator.generateTexts(
        texts,
        wmContainerWidth,
        wmMarginHor,
        wmLineGap,
        wmLineWidth,
        pinOffset
      );

      //Head and Tails
      let allHeadTailsData = WiremapGenerator.generateHeadTail(
        data,
        wmContainerWidth,
        wmMarginHor,
        wmHeadTailsWidth,
        wmLineGap,
        wmLineWidth,
        pinOffset
      );

      //Lines
      let allLinesData = WiremapGenerator.generateLines(
        data,
        wmContainerWidth,
        wmMarginHor + wmHeadTailsWidth,
        wmLineGap,
        wmLineWidth,
        isCoax,
        pinOffset
      );
      let linesData = allLinesData.lines;
      let shortLinesData = allLinesData.shortlines;
      let openLinesData = allLinesData.openlines;

      let lineFunction = d3
        .line()
        .x(function(d) {
          return d.x;
        })
        .y(function(d) {
          return d.y;
        })
        .curve(d3.curveMonotoneX);

      return (
        <div id="wmContainer" ref="wmContainer" className={classes.root}>
          <svg width={wmContainerWidth} height={wmContainerHeight}>
            <defs>
              <marker
                id="ShortMarker"
                markerWidth={wmLineWidth / 3}
                markerHeight={wmLineWidth / 3}
                refX={wmLineWidth / 6}
                refY={wmLineWidth / 6}
              >
                <circle
                  cx={wmLineWidth / 6}
                  cy={wmLineWidth / 6}
                  r={wmLineWidth / 12}
                  style={{ stroke: colors.short, fill: colors.short }}
                />
              </marker>
            </defs>
            {textsData.map((d, i) => {
              return (
                <text
                  key={`wiremapdia-t-${i}`}
                  x={d.x}
                  y={d.y}
                  fontSize={d.fontSize}
                  fontWeight="bold"
                  textAnchor={d.textAnchor}
                >
                  {d.text}
                </text>
              );
            })}
            {allHeadTailsData.headlines.map((d, i) => {
              return (
                <path
                  key={`wiremapdia-l-${i}`}
                  d={lineFunction(d.line)}
                  stroke={colors[d.pin]}
                  strokeWidth={wmLineWidth}
                  fill="none"
                  style={d.dash ? { strokeDasharray: "20, 6" } : {}}
                ></path>
              );
            })}
            {linesData.map((d, i) => {
              return (
                <path
                  key={`wiremapdia-l-${i}`}
                  d={lineFunction(d.line)}
                  stroke={d.lineColor ? d.lineColor : colors[d.pin]}
                  strokeWidth={d.lineWidth ? d.lineWidth : wmLineWidth}
                  fill="none"
                  style={d.dash ? { strokeDasharray: "20, 6" } : {}}
                ></path>
              );
            })}
            {allHeadTailsData.taillines.map((d, i) => {
              return (
                <path
                  key={`wiremapdia-l-${i}`}
                  d={lineFunction(d.line)}
                  stroke={colors[d.pin]}
                  strokeWidth={wmLineWidth}
                  fill="none"
                  style={d.dash ? { strokeDasharray: "20, 6" } : {}}
                ></path>
              );
            })}
            {shortLinesData.map((d, i) => {
              return (
                <path
                  key={`wiremapdia-s-${i}`}
                  d={lineFunction(d.line)}
                  stroke={colors.short}
                  strokeWidth={wmLineWidth / 3}
                  fill="none"
                  markerStart={d.marker ? "url(#ShortMarker)" : ""}
                  markerEnd={d.marker ? "url(#ShortMarker)" : ""}
                ></path>
              );
            })}
            {openLinesData.map((d, i) => {
              return (
                <path
                  key={`wiremapdia-o-${i}`}
                  d={lineFunction(d.line)}
                  stroke="black"
                  strokeWidth={wmLineWidth / 3}
                  fill="none"
                ></path>
              );
            })}
          </svg>
        </div>
      );
    } else {
      return (
        <div id="wmContainer" ref="wmContainer" className={classes.root}></div>
      );
    }
  }

  resizeWiremap() {
    if (this.refs && this.refs.wmContainer) {
      let containerWidth = this.refs.wmContainer.offsetWidth;
      this.setState({
        wmContainerWidth: containerWidth
      });
    }
  }

  componentDidMount() {
    this.resizeWiremap();
    window.addEventListener("resize", this.resizeWiremap.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeWiremap.bind(this));
  }
}

export default withStyles(styles)(WiremapDiagram);
